<article class="renderizador-pagina">
  @if (tieneError()) {
    <div class="renderizador-pagina__error" role="alert">
      <h2>Error al cargar la página</h2>
      <p>{{ mensajeError() }}</p>
    </div>
  } @else if (componentesPagina().length > 0) {
    <div class="renderizador-pagina__contenido">
      @for (componente of componentesPagina(); track componente.tipoComponente) {
        <app-renderizador-dinamico [configuracionComponente]="componente" [registroComponentes]="registroComponentes()">
        </app-renderizador-dinamico>
      }
    </div>
  }
</article>
